export var DataType;
(function (DataType) {
    DataType["Object"] = "object";
    DataType["String"] = "string";
    DataType["Boolean"] = "boolean";
    DataType["Integer"] = "integer";
    DataType["Array"] = "array";
    DataType["Number"] = "number";
})(DataType || (DataType = {}));
export var StringFormat;
(function (StringFormat) {
    /**
     * 日期
     */
    StringFormat["Date"] = "date";
    /**
     * 日期+时间
     */
    StringFormat["DateTime"] = "date-time";
    /**
     * 时间
     */
    StringFormat["Time"] = "time";
    /**
     * 持续时间
     */
    StringFormat["Duration"] = "duration";
    StringFormat["Password"] = "password";
    /**
     * base64-encoded
     */
    StringFormat["Byte"] = "byte";
    /**
     * 文件上传格式
     * binary file contents
     */
    StringFormat["Binary"] = "binary";
    StringFormat["Email"] = "email";
    StringFormat["Uuid"] = "uuid";
    StringFormat["Uri"] = "uri";
    StringFormat["Hostname"] = "hostname";
    StringFormat["IPv4"] = "ipv4";
    StringFormat["IPv6"] = "ipv6";
})(StringFormat || (StringFormat = {}));
export var NumberFormat;
(function (NumberFormat) {
    NumberFormat["Int32"] = "int32";
    NumberFormat["Int64"] = "int64";
    NumberFormat["Float"] = "float";
    NumberFormat["Double"] = "double";
})(NumberFormat || (NumberFormat = {}));
/**
 * 控件属性值类型
 */
export var ControlAttributeType;
(function (ControlAttributeType) {
    ControlAttributeType[ControlAttributeType["Boolean"] = 0] = "Boolean";
    ControlAttributeType[ControlAttributeType["String"] = 1] = "String";
    ControlAttributeType[ControlAttributeType["Dropdown"] = 2] = "Dropdown";
    ControlAttributeType[ControlAttributeType["Modal"] = 3] = "Modal";
    ControlAttributeType[ControlAttributeType["Date"] = 4] = "Date";
    ControlAttributeType[ControlAttributeType["SelectTree"] = 5] = "SelectTree";
    ControlAttributeType[ControlAttributeType["Tree"] = 6] = "Tree";
    ControlAttributeType[ControlAttributeType["Userpicker"] = 7] = "Userpicker";
    ControlAttributeType[ControlAttributeType["Array"] = 8] = "Array";
})(ControlAttributeType || (ControlAttributeType = {}));
/**
 * 下拉弹窗属性
 */
export var DropdownAttributeType;
(function (DropdownAttributeType) {
    DropdownAttributeType[DropdownAttributeType["Number"] = 0] = "Number";
    DropdownAttributeType[DropdownAttributeType["Summary"] = 1] = "Summary";
    DropdownAttributeType[DropdownAttributeType["UploadSize"] = 2] = "UploadSize";
    DropdownAttributeType[DropdownAttributeType["ControlType"] = 3] = "ControlType";
    DropdownAttributeType[DropdownAttributeType["Location"] = 4] = "Location";
})(DropdownAttributeType || (DropdownAttributeType = {}));
